export const trimOuterPlusSigns = (value) => {
  if (!value || typeof value !== "string") return value;
  return value.trim();
};
